<template>
  <resource-edit-wrapper
    :title="$t('resources.sidebars.edit_sidebar')"
    :need-modal="showModal"
    @saveAction="$refs['sidebarForm'].submit()">
    <SidebarForm is-edit :sidebar="item" @isDirtyForm="isDirtyForm" ref="sidebarForm"></SidebarForm>
  </resource-edit-wrapper>
</template>

<script>
  import ResourceEditWrapper from "@/components/resourceWrappers/ResourceEditWrapper";
  import SidebarForm from "@/components/forms/SidebarForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";

  export default {
    components: {
      ResourceEditWrapper,
      SidebarForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      id: {
        type: String,
        required: false,
        default: "",
      },
      title: {
        type: String,
        required: true,
      },
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    created() {
      this.$admin.toast.info(this.$t("generic.edit_warning.warning") + this.$t("generic.edit_warning.sidebar"));
    },
  };
</script>
